import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import NosServices from "./sections/NosServices";
import SecondaryCta from "./sections/SecondaryCta";
import PiedDePage from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <NosServices />
      <SecondaryCta />
      <PiedDePage />
    </div>;
}